import p3on from "../assets/p3-on.webp";
import p3off from "../assets/p3-off.webp";
import p4on from "../assets/p4-on.webp";
import p4off from "../assets/p4-off.webp";
import p5on from "../assets/p5-on.webp";
import p5off from "../assets/p5-off.webp";
import p6on from "../assets/p6-on.webp";
import p6off from "../assets/p6-off.webp";
import p7on from "../assets/p7-on.webp";
import p7off from "../assets/p7-off.webp";
import p8on from "../assets/p8-on.webp";
import p8off from "../assets/p8-off.webp";
import p9on from "../assets/p9-on.webp";
import p9off from "../assets/p9-off.webp";
import p10on from "../assets/p10-on.webp";
import p10off from "../assets/p10-off.webp";

/* Extra product-page shots. Replace these two files with your own —
   same names, same folder. Keep them 4:5 (980x1225) so the
   thumbnails stay aligned with the lit/unlit pair. */
import l3room from "../assets/l3-room.png";
// import l4extra from "../assets/l4-extra.webp";

/* ------------------------------------------------------------------
   Everything editable lives here.

   Product-page thumbnails, in order:
     1. off   — the unlit shot (also used in the grid)
     2. on    — the lit shot   (also used in the grid)
     3. room  — ambient / in-situ shot, static
     4. extra — spare slot, static

   Slots 1 and 2 are wired to the switch: flipping it selects the
   matching thumbnail automatically. Slots 3 and 4 are plain photos —
   the switch does not affect them. Omit `room` or `extra` and that
   thumbnail simply is not rendered.
------------------------------------------------------------------ */

const products = [
  {
    id: "linea",
    name: "Linea",
    type: "Varëse lineare",
    price: 240,
    oldPrice: 290,
    spec: "90 cm · 2700K · 18W",
    on: p3on,
    off: p3off,
    /* Product-page thumbnail strip, in order.
       Slots 1 and 2 are driven by the switch; the rest are static. */
    room: l3room,
    // extra: l4extra,
    description:
      "Një vijë e vetme drite mbi tryezë. Linea është projektuar për hapësira ku ndriçimi duhet të ndihet, jo të shihet — trupi i hollë prej alumini zhduket në sfond dhe mbetet vetëm drita.",
    details: [
      ["Materiali", "Alumin i lyer, difuzor opal"],
      ["Përmasat", "90 × 4 × 6 cm"],
      ["Ngjyra e dritës", "2700K — e ngrohtë"],
      ["Fuqia", "18W LED, e integruar"],
      ["Dimmer", "Po, i pajtueshëm"],
      ["Garancia", "3 vjet"],
    ],
    stock: 6,
  },
  {
    id: "duo",
    name: "Duo",
    type: "Aplikë muri",
    price: 130,
    spec: "24 cm · 2700K · 8W",
    on: p4on,
    off: p4off,
    stock: 12,
  },
  {
    id: "stelo",
    name: "Stelo",
    type: "Aplikë me shtyllë",
    price: 165,
    spec: "70 cm · 2700K · 8W",
    on: p5on,
    off: p5off,
    stock: 4,
  },
  {
    id: "opal",
    name: "Opal",
    type: "Varëse qelqi",
    price: 190,
    spec: "28 cm · 2700K · 12W",
    on: p6on,
    off: p6off,
    stock: 9,
  },
  {
    id: "kupa",
    name: "Kupa",
    type: "Varëse metalike",
    price: 175,
    spec: "36 cm · 2700K · 12W",
    on: p7on,
    off: p7off,
    stock: 7,
  },
  {
    id: "volta",
    name: "Volta",
    type: "Llambë tavoline",
    price: 145,
    spec: "42 cm · 2700K · 9W",
    on: p8on,
    off: p8off,
    stock: 15,
  },
  {
    id: "fiore",
    name: "Fiore",
    type: "Llambadar",
    price: 620,
    spec: "80 cm · 9 drita · 2700K",
    on: p9on,
    off: p9off,
    stock: 2,
  },
  {
    id: "disk",
    name: "Disk",
    type: "Aplikë rrethore",
    price: 210,
    spec: "40 cm · 2700K · 14W",
    on: p10on,
    off: p10off,
    stock: 8,
  },
];

export default products;
export const findProduct = (id) => products.find((p) => p.id === id);
